import { useRef, useState } from "react";
import SearchFilterComponent from "../../Common/SearchFilterComponent/SearchFilterComponent";
import TemplatesTable from "../../distributor-settings/email-templates/templates-table";
import styles from "./index.module.scss";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Flaggers } from "../../../common/store/flaggers/flaggers.enum";
import { ModalData } from "../../../common/types/app.types";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import InviteTemplateModal from "../../distributor-settings/email-templates/invite-template-modal";
import { emailTemplateValidationSchema, getEmailTemplateInitialValues } from "../../../common/validations/email-templates.validations";
import FormContent from "../../distributor-settings/email-templates/invite-template-modal/form-options/invite-options";
import PreviewContent from "../../distributor-settings/email-templates/invite-template-modal/preview-content/invite-content";

const EmailTemplates = () => {
  const { entityData: inviteTemplateModalData, setEntityData } = useEntity<ModalData>({ entityType: Flaggers.PreviewInviteTemplateFlagger })

  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchOnCross = () => {
    setSearchValue('');
  };

  const handleOpenInviteTemplateModal = () => {
    setEntityData({ show: true }, FlaggersMethods.UpdateFlagger)
  }

  const handleCloseInviteTemplateModal = () => {
    setEntityData({ show: false }, FlaggersMethods.UpdateFlagger)
  }

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <SearchFilterComponent
          leftSide={
            <div>
              <span className="m-0 f-16 line-height-24 f-600 f-black">
                Email Templates
              </span>
            </div>
          }
          searchValue={searchValue}
          searchOnChange={handleSearchOnChange}
          searchOnCross={handleSearchOnCross}
          passedRef={searchInputRef}
          setRef={() => {
            searchInputRef.current?.focus();
          }}
          showLastButton={false}
          noToSearch={true}
        />
        <TemplatesTable onPreviewInviteTemplate={handleOpenInviteTemplateModal} />
      </div>
      <InviteTemplateModal 
        title="Preview & Edit Template: Invites" show={inviteTemplateModalData?.show} onHide={handleCloseInviteTemplateModal} 
        initialValues={getEmailTemplateInitialValues()}
        validationSchema={emailTemplateValidationSchema}
        formContentComponent={(formikProps) => <FormContent formikProps={formikProps} />}
        previewComponent={(formValues) => <PreviewContent formValues={formValues} />}
        onSubmit={(values) => {
          console.log(values);
        }}
      />
    </div>
  )
}

export default EmailTemplates;